module.exports = __webpack_public_path__ + "img/audioPlay.84433cfa.svg";